import React, {useEffect, useState} from "react";
import {styled} from "@mui/material/styles";
import LoadingButton from "@mui/lab/LoadingButton";

import Form from "@/components/form/Form.jsx";
import Input from "@/components/form/MUIInput.jsx";
import LocationSearchInput from "@/components/form/LocationSearchInput.jsx";

export default function SearchJobsFilter({initData, mobileStyle = 'default', onSubmit}) {
    const [buttonIsDisabled, setButtonIsDisabled] = useState(false);

    const [keyword, setKeyword] = useState(initData?.keyword ?? '');
    const [locationName, setLocationName] = useState(initData?.location?.name ?? '');

    const [location, setLocation] = useState(initData?.location);
    const [locationError, setLocationError] = useState('');

    const submitInProcess = useState(false);

    useEffect(() => {
        if(submitInProcess.current) {
            submitInProcess.current = false;
            onSubmit(keyword, location);
        }
    }, [location]);

    const handleKeywordChange = (e) => {
        e.persist();
        setKeyword(e.target.value);
    };

    const handleLocationChange = (new_location, new_location_name) => {
        setLocation(new_location);
        setLocationName(new_location_name);
    };

    const handleLocationKeyDown = () => {
        submitInProcess.current = false;
    };

    const handleSubmit = () => {
        if(buttonIsDisabled) {
            return
        }

        submitInProcess.current = true;
        onSubmit(keyword, location);
    };

    return (
        <Form onSubmit={handleSubmit} allowSubmitOnEnter={false}>
            <Container mobileOneLine={mobileStyle == 'one-line'}>
                <Input
                    label={""}
                    placeholder={"Keyword or company"}
                    style={{borderRadius: 22.5}}
                    fullWidth
                    value={keyword}
                    onChange={handleKeywordChange}
                />

                <LocationSearchInput
                    label={""}
                    placeholder={"Enter city"}
                    fullWidth
                    value={locationName}
                    initLocation={location}
                    errorMessage={locationError}
                    onFocus={() => setLocationError('')}
                    onLoading={() => setButtonIsDisabled(true)}
                    onEndLoading={() => setButtonIsDisabled(false)}
                    onKeyDown={handleLocationKeyDown}
                    onChange={handleLocationChange}
                />

                <LoadingButton
                    key="search-filter-btn"
                    loading={false}
                    disabled={buttonIsDisabled}
                    variant="contained"
                    type="submit"
                    size="medium"
                >
                    <span>Search jobs</span>
                    {mobileStyle == 'one-line' && <b>→</b>}
                </LoadingButton>
            </Container>
        </Form>
    );
}

const Container = styled('div')(({mobileOneLine}) => ({
    display: 'flex',
    gap: '7px',
    maxWidth: '676px',
    margin: 'auto',

    '@media (max-width: 767px)': {
        flexDirection: 'column',
    },

    '& .MuiFormControl-root': {
        borderRadius: '22.5px',
    },

    '& .MuiInputBase-input': {
        fontSize: '19px',
        fontWeight: '700',
    },

    '& .MuiFormControl-root::-moz-placeholder': {
        color: 'red !important',
    },

    '& .MuiButton-root': {
        minWidth: '160px',

        '& span': {
            fontWeight: 'inherit',
        },

        '& b': {
            display: 'none',
        },
    },

    ...(mobileOneLine && {
        '@media (max-width: 767px)': {
            flexDirection: 'row !important',

            '& > div + div': {
                width:  '260px !important',
            },

            '& .MuiInputBase-input': {
                fontSize: '15px !important',
                fontWeight: '600 !important',
                paddingLeft: '10px !important',
            },

            '& .MuiButton-root': {
                minWidth: '50px !important',
                paddingLeft: '0 !important',
                paddingRight: '0 !important',

                '& span': {
                    display: 'none !important',
                },

                '& b': {
                    display: 'inline !important',
                },
            },
        },
    }),
}));

